import {MODEL_REASONING_EFFORTS,type PlatformModelCapabilities} from '@reados/contracts';
import {setModelReasoningEffort} from '../platform-model-form';

/** Controlled by the model draft; no separate free-text or default state. */
export function ModelReasoningFields({capabilities,onChange}:{capabilities:PlatformModelCapabilities;onChange:(value:PlatformModelCapabilities)=>void}){
 return <>
  <fieldset className="admin-model-wide"><legend>可选推理强度</legend>
   <div className="admin-model-fields">{MODEL_REASONING_EFFORTS.map(effort=><label className="admin-model-check" key={effort}><input type="checkbox" checked={capabilities.reasoningEfforts.includes(effort)} onChange={event=>onChange(setModelReasoningEffort(capabilities,effort,event.target.checked))}/>{effort}</label>)}</div>
   <small>仅勾选供应商实际支持的档位；留空表示不提供手动推理强度选项。</small>
  </fieldset>
  <label>默认推理强度<select value={capabilities.defaultReasoningEffort??''} onChange={event=>onChange({...capabilities,defaultReasoningEffort:event.target.value||null})}><option value="">供应商默认</option>{capabilities.reasoningEfforts.map(effort=><option key={effort} value={effort}>{effort}</option>)}</select></label>
 </>;
}
